// extracted by mini-css-extract-plugin
export default {"stampDutyPage":"StampDutyPage_stampDutyPage__mSJlL","specialH2":"StampDutyPage_specialH2__58l5i","aboutStampDuty":"StampDutyPage_aboutStampDuty__f3zuT"};